var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnLink = function SvgBtnLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.657 2.343a4 4 0 0 1 .104 5.549L13.657 8l-.943.943a.667.667 0 0 1-.995-.885L11.771 8l.943-.943a2.667 2.667 0 0 0-3.675-3.863l-.096.092L8 4.229a.667.667 0 0 1-.995-.885l.052-.058L8 2.343a4 4 0 0 1 5.657 0ZM9.414 11.3a.667.667 0 0 1 .052.884l-.052.059L8 13.656a4 4 0 0 1-5.761-5.55L2.343 8l1.414-1.414a.667.667 0 0 1 .995.884l-.052.058-1.414 1.415a2.667 2.667 0 0 0 3.675 3.863l.096-.092L8.471 11.3c.26-.26.683-.26.943 0Zm.471-5.186a.667.667 0 0 0-.942 0L6.114 8.943a.667.667 0 1 0 .943.942l2.828-2.828a.667.667 0 0 0 0-.943Z",
    fill: "#7E8185"
  })));
};
export default SvgBtnLink;